import axios from 'axios';
import miscFunctions from '../helpers/misc-functions';
import Metadata from '../helpers/metadata/Metadata';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';
import dataModel from '../models/DataModel';

let helpers = {
  getProjectTypesByCompany(company_id, searchString = '', market_id, options = {}, published) {
    let url = process.env.REACT_APP_API + '/project_types?current_company=' + company_id + '&keywords=' + (searchString ? searchString : '')
      + (market_id ? '&market_id=' + market_id : '')
      + (options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    if(published){
      url+='&published='+published;
    }
    return axios({
      method: 'get',
      url,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getProjectType: (project_type_id, company_id, options = {}) => {
    const url = process.env.REACT_APP_API + '/project_types/'
      + project_type_id + '?current_company='
      + (company_id ? company_id : localStorage.current_company_id)
      + (options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'get',
      url,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createProjectType(project_type, eventMetadatum, options = {}) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    project_type.company_id = project_type.company ? project_type.company.id : project_type.company_id;
    delete project_type.company;
    const url = process.env.REACT_APP_API + '/project_types?current_company=' + localStorage.current_company_id
      + (options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'post',
      url,
      data: {
        event_metadatum: eventMetadatum,
        project_type: project_type,
      },
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateProjectType(project_type, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const url = process.env.REACT_APP_API + '/project_types/' + project_type.id + '?current_company=' + localStorage.current_company_id
      + (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'patch',
      url,
      data: {
        event_metadatum: eventMetadatum,
        project_type: project_type,
      },
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteProjectType(project_type_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/project_types/' + project_type_id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return { status: 'success' };
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getProjectTemplate: (project_template_id, company_id, filter) => {
    const url = process.env.REACT_APP_API + '/project_templates/' + project_template_id + '?current_company='
      + (company_id ? company_id : localStorage.current_company_id)
      + (filter ? '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(filter) : '');
    return axios({
      method: 'get',
      url: url,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });

  },
  createProjectTemplate(project_template, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    let company_id = localStorage.current_company_id;
    if (project_template.company) {
      company_id = project_template.company.id;
      delete project_template.company;
    }
    project_template.project_type_id = project_template.project_type ? project_template.project_type.id :
      project_template.project_type_id;
    delete project_template.project_type;
    const url = process.env.REACT_APP_API + '/project_templates?current_company=' + company_id
      + (options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'post',
      url,
      data: {
        event_metadatum: eventMetadatum,
        project_template: project_template,
      },
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateProjectTemplate(project_template, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const url = process.env.REACT_APP_API + '/project_templates/' + project_template.id + '?current_company=' + localStorage.current_company_id
      + (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    delete project_template.builds;
    delete project_template.location;
    return axios({
      method: 'patch',
      url,
      data: {
        event_metadatum: eventMetadatum,
        project_template: project_template,
      },
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteProjectTemplate(project_template_id, is_template, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/project_templates/' + project_template_id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        is_template: is_template,
      },
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return { status: 'success' };
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  copyProjectTemplate(project_type_id, project_template_id, project_template_name, markets, company_id, eventMetadatum, options) {
    dataModel.inProgress = 30000;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const url = process.env.REACT_APP_API + '/project_templates/' + project_template_id + '/copy?current_company=' + localStorage.current_company_id
    + (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'post',
      url,
      data: {
        event_metadatum: eventMetadatum,
        destination_company_id: company_id,
        project_type_id: project_type_id,
        name: project_template_name,
        markets: markets,
      },
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        dataModel.inProgress = 0;
        return response.data;
      })
      .catch(error => {
        dataModel.inProgress = 0;
        return serviceUtil.resultForError(error);
      });
  },
  getProjectTemplateCloseouts() {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/company_closeout_templates?current_company=' + localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        let record = miscFunctions.mapApiJson(response.data);
        return record;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },

  publishTemplateVersion(templateId, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const url = process.env.REACT_APP_API + '/project_templates/' + templateId + '/publish?current_company=' + localStorage.current_company_id
      + (options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'patch',
      url,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createProjectTemplateVersion(project_template_id, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const url = process.env.REACT_APP_API + '/project_templates/' + project_template_id + '/new_version?current_company=' + localStorage.current_company_id
      + (options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'post',
      url,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
      },
    })
      .then(response => {
        return { data: response.data, status: response.status };
      })
      .catch(error => {
        const errResult = serviceUtil.resultForError(error);
        return errResult && typeof errResult === 'object' ? errResult : { error: errResult };
      });
  },

  /**
   * All versions in a template group, ordered by version.
   *
   * Used to watch for a version created by a backgrounded new_version: that request returns
   * 202 with only a group_identifier, so there is no id to fetch until the job finishes.
   */
  getProjectTemplatesByGroup(group_identifier) {
    const url = process.env.REACT_APP_API + '/project_templates?current_company=' + localStorage.current_company_id
      + '&group_identifier=' + encodeURIComponent(group_identifier);
    return axios({
      method: 'get',
      url,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => miscFunctions.mapApiJson(response.data) || [])
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },

  getMigratableProjects(templateId) {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/project_templates/' + templateId + '/migratable_projects?current_company=' + localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return miscFunctions.mapApiJson(response.data);
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },

  migrateAndPublish(templateId, projectIds, eventMetadatum, options) {
    dataModel.inProgress = 120000;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/project_templates/' + templateId + '/migrate?current_company=' + localStorage.current_company_id,
      timeout: 120000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        project_ids: projectIds,
      },
    })
      .then(response => {
        dataModel.inProgress = 0;
        return response;
      })
      .catch(error => {
        dataModel.inProgress = 0;
        return serviceUtil.resultForError(error);
      });
  },

  addReferenceDocument(projectTemplageId, referenceDocumentId, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/project_templates/' + projectTemplageId + '/add_reference_document?reference_document_id=' + referenceDocumentId + '&current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteReferenceDocument(projectTemplageId, referenceDocumentId, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/project_templates/' + projectTemplageId + '/remove_reference_document?reference_document_id=' + referenceDocumentId + '&current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/projectTemplatesService.js